import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

interface DayCheckboxProps {
  checked: boolean;
  label: string
  onChange: (e: React.ChangeEvent) => void;
  disabled: boolean;
}

const DayCheckBox = ({
  checked,
  label,
  onChange,
  disabled,
}: DayCheckboxProps) => {

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            sx={{
              '& .MuiCheckbox-root.Mui-checked': {
                backgroundColor: '#00CECF4D',
              },
            }}
            checked={checked}
            onChange={onChange}
          />
        }
        label={
          <Typography variant='body2' style={{ fontSize: '15px', color: '#181818' }}>
            {label}
          </Typography>
        }
        disabled={disabled}
        sx={{
          color: '#00000080',
          '& .MuiCheckbox-root': {
            opacity: '0.4',
          },
          '& .MuiCheckbox-root.Mui-checked': {
            color: '#00CECF',
          },
        }}
      />
    </Box>
  );
};

export default DayCheckBox;